/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - مقابلة أناس جدد، الدردشة، النقاش",
      "رقم هاتف غير صحيح",
      "Get the app",
      "المواصلة عبر الآبل",
      "مواصلة عبر الفايسبوك",
      "مواصلة عبر جوجل",
      "تسجيل الدخول",
      "تسجيل",
      "للمواصلة، يرجى إعادة كتابة هته الرموز.",
      "مواصلة",
      "يرجى إدخال الرموز التي تظهر لك",
      "تحقق أمني",
      "إعادة التحميل",
      "المرجو إنشاء رقم سري جديد يمكنك تذكره بسهولة مستقبلا:",
      "تحديث",
      "تأكيد كلمة المرور",
      "كلمة المرور يجب أن تحتوي على الأقل على {{num}} [[characters:num]]",
      "كلمة المرور",
      "إنشاء كلمة سر جديدة",
      "Badoo - The Blog",
      "فرص عمل",
      "دردشة",
      "المدن",
      "إدارة ملف الكوكيز",
      "حقوق النشر © 2006 – إلى الآن. Bumble. جميع الحقوق محفوظة.",
      "Apple وشعار Apple هما علامتان تجاريّتان لشركة Apple Inc.{{__EOL__}}متجر Google هي علامة تجاريّة تابعة لشركةGoogle LLC.",
      "تحميل",
      "الفايسبوك",
      "تابعنا",
      "مركز المساعدة",
      "الإنستغرام",
      "اللغة",
      "لينكد إن",
      "رؤية عامة",
      "Badoo تابعة لشركة Bumble.",
      "قوانين الخصوصية",
      "مركز الأمن",
      "خريطة الموقع",
      "بيان قانون العبودية الحديثة",
      "الشروط و القوانين",
      "التويتر",
      "يرجى إدخال بريدك الإلكتروني أو رقم هاتفك، وسوف نقوم بإرسال رسالة لك تتضمن رابط خاص يساعدك على إنتاج كلمة سر جديدة.",
      "الحصول على كلمة سر جديدة",
      "يرجى إدخال بريدك الإلكتروني أو رقم هاتفك",
      "نسيت كلمة المرور",
      "الصور ترويجية لأغراض توضيحية فقط",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "لا داعي لإنتظار التطابق.{{__EOL__}}{{__EOL__}}يمكنك بدأ المغامرة آنيا، لديك كل ما يلزم من معرفة.",
      "لديك إستعداد لبدأ الدردشة الآن؟",
      "مواصلتك للتسجيل، تعني موافقتك على <a class=\"link\" href=\"{{terms_url}}\">قوانين وشروط الاستعمال</a>. ألق نظرة على كيفية استعمالنا لمعلوماتك على <a class=\"link\" href=\"{{privacy_url}}\">صفحة الخصوصية</a>.",
      "مكان مناسب لإظهار شخصيتك، <br />ومواعدة مناسبة لك.",
      "حان الوقت لتقوم بالتعارف بكل ثقتك.",
      "أو",
      "لديك حساب مسبقا؟",
      "تسجيل الحساب عبر بريد إلكتروني أو رقم هاتفي",
      "الكشف عن نواياك.{{__EOL__}}يساعد باقي الناس في التعرف عليك بسلاسة أكبر.",
      "الإكتفاء بالدردشة هو هدفك؟{{__EOL__}}لا مشكل. الإستقرار العاطفي مرادك؟ رائع!{{__EOL__}}{{__EOL__}}وفي حالة رغبت في تغيير رأيك. يمكنك ذلك.",
      "هنا للتعارف",
      "على استعداد لعلاقة جدية",
      "على استعداد للدردشة",
      "حان وقت ملاقاة أناس يشاركونك نفس الاهتمامات.",
      "{{name}}، {{age}}",
      "سلامتك هي أولويتنا الخاصة.",
      "ألق نظرة على مركز الأمان ومركز المعرفة الخاص بنا، للحصول على كل الدعم اللازم للمواعدة بكل ثقة.",
      "ألق نظرة على مركز Badoo للأمن",
      "السلامة أولا،<br/>ثانيا ودائما.",
      "من أول لحظة، أحسست أن الأمر سينجح...",
      "في البداية، لم أكن أبحث عن أي شيء جاد...",
      "الأمر يكون بسهولة أكبر على Badoo في حالة كنت على حقيقتك...",
      "قصص Badoo الناجحة",
      "ألق نظرة على المزيد من القصص الناجحة",
      "{{num}}__CUT__معدل التصويتات",
      "متجر التطبيقات آبل",
      "ثق بنا. لقد جمعنا الملايين (والملايين والملايين) من الناس معًا.",
      "+{{num}} مليون__CUT__تحميل",
      "+{{num}} مليون",
      "متجر التطبيقات جوجل",
      "نحن نعرف ما نقوم به.",
      "تسجيل الدخول عبر بريد إلكتروني أو رقم هاتفي",
      "إدخال  كلمة السر",
      "نسيت كلمة المرور؟",
      "تسجيل حساب جديد",
      "ليس لديك حساب؟",
      "تسجيل الدخول",
      "تسجيل الحساب"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "أحرف"
            ],
            "many": [
                  "حرف"
            ],
            "plural": [
                  "حرف"
            ],
            "singular": [
                  "حرف"
            ],
            "two": [
                  "حرفان"
            ]
      },
      "day": {
            "few": [
                  "أيام"
            ],
            "many": [
                  "يوم"
            ],
            "plural": [
                  "يوم"
            ],
            "singular": [
                  "يوم"
            ],
            "two": [
                  "يومان"
            ],
            "zero": [
                  "يوم"
            ]
      },
      "hour": {
            "few": [
                  "ساعات"
            ],
            "many": [
                  "ساعة"
            ],
            "plural": [
                  "ساعة"
            ],
            "singular": [
                  "ساعة"
            ],
            "two": [
                  "ساعتان  "
            ]
      },
      "minute": {
            "few": [
                  "دقائق"
            ],
            "many": [
                  "دقيقة"
            ],
            "plural": [
                  "دقيقة"
            ],
            "singular": [
                  "دقيقة"
            ],
            "two": [
                  "دقيقتان "
            ]
      },
      "month": {
            "few": [
                  "أشهر"
            ],
            "many": [
                  "شهر"
            ],
            "plural": [
                  "شهر"
            ],
            "singular": [
                  "شهر"
            ],
            "two": [
                  "شهران"
            ],
            "zero": [
                  "شهر"
            ]
      },
      "second": {
            "few": [
                  "ثوان "
            ],
            "many": [
                  "ثانية"
            ],
            "plural": [
                  "ثانية"
            ],
            "singular": [
                  "ثانية"
            ],
            "two": [
                  "ثانيتان  "
            ]
      },
      "year": {
            "few": [
                  "سنين"
            ],
            "many": [
                  "سنة"
            ],
            "plural": [
                  "سنة"
            ],
            "singular": [
                  "سنة"
            ],
            "two": [
                  "سنتان"
            ],
            "zero": [
                  "سنة"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
